module.exports = __webpack_public_path__ + "img/banner.8e29ebb3.png";